import React from 'react';
import { Control } from 'react-hook-form';
import { CheckboxController } from '@components-clean/core/core-checkbox';
import DragDropListsCore from '@components-clean/core/drag-drop-lists-core';
import { DragDropListItemProps } from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.interface';
import { useTranslation } from '@hooks/index';

interface EditFormValues {
    active: boolean;
    reviewSubject: boolean;
}

interface EditReviewPlanStep1Props {
    control: Control<EditFormValues>;
    includedListings: DragDropListItemProps[];
    availableListings: DragDropListItemProps[];
    onIncludedChange: (items: DragDropListItemProps[]) => void;
    onAvailableChange: (items: DragDropListItemProps[]) => void;
    noDataListingsConfigured: boolean;
}

const EditReviewPlanStep1 = ({
    control,
    includedListings,
    availableListings,
    onIncludedChange,
    onAvailableChange,
    noDataListingsConfigured,
}: EditReviewPlanStep1Props) => {
    const { t } = useTranslation();

    return (
        <div className="k-d-flex k-flex-col k-gap-3 k-px-4 k-py-2 k-h-full">
            <form className="k-d-flex k-gap-4">
                <CheckboxController
                    control={control}
                    name="active"
                    data-testid="edit-review-plan-active"
                    label={t('admin:smReviewPlans.fields.active')}
                />
                <CheckboxController
                    control={control}
                    name="reviewSubject"
                    data-testid="edit-review-plan-review-subject"
                    label={t('admin:smReviewPlans.fields.reviewSubject')}
                />
            </form>
            {noDataListingsConfigured ? (
                <div
                    data-testid="no-data-listings-warning"
                    className="k-d-flex k-align-items-center k-justify-content-center k-h-full"
                >
                    {t('admin:smReviewPlans.editDialog.noDataListings')}
                </div>
            ) : includedListings.length > 0 || availableListings.length > 0 ? (
                <div className="k-flex-1 k-overflow-hidden ">
                    <DragDropListsCore
                        isTwoLists
                        idField="dataListingId"
                        list1Header={t('admin:smReviewPlans.editDialog.dataListingsToReview')}
                        list2Header={t('admin:smReviewPlans.editDialog.availableDataListings')}
                        list1Items={includedListings}
                        list2Items={availableListings}
                        onChangeItemsLeft={onIncludedChange}
                        onChangeItemsRight={onAvailableChange}
                        disableReorder
                    />
                </div>
            ) : null}
        </div>
    );
};

export default EditReviewPlanStep1;
